<template>
  <div class="edit-transaction-income">
    <div class="modal-header">
      <h2>Izmeni iznos uplate korisnika blagajne</h2>
    </div>
    <div class="body">
      <div class="edit-input-wrapper">
        <div class="amount--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--amount"
            placeholder=" "
            v-model.lazy="amount"
            v-money="{}"
          />
          <span class="input-span input-span--amount">Iznos</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>
      <div class="buttons">
        <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
        <button type="submit" class="btn btn-primary btn--mod" :disabled="loading" @click="save">
          <p v-if="!loading">Izmeni</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex';

import { financesInstance } from '@/axios/axios.js';

export default {
  created() {
    document.addEventListener('keydown', this.processKeyboardEvent);
    this.amount = this.transaction.amount * 100;
    this.amount = this.amount.toFixed(0);
  },
  data() {
    return {
      loading: false,
      total: 0,
      errorOccurred: false,
      amount: 0
    };
  },
  computed: {
    ...mapState('modal', ['transaction']),
    ...mapState('finances', ['transactions'])
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('finances', ['getTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      } else if (e.key === 'Enter') {
        this.save();
      }
    },
    getTodayDateFormatted() {
      let todayDate = new Date().toISOString();
      let dateYear = todayDate.split('T')[0];
      let dateHour = todayDate.split('T')[1].split('.')[0];
      return dateYear + ' ' + dateHour;
    },
    save() {
      this.loading = true;
      this.errorOccurred = false;
      console.log(this.transaction);
      if (this.doesErrorExist()) {
        this.errorMessage = 'Neispravan unos podataka';
        this.errorOccurred = true;
        this.loading = false;
        return;
      }
      let todayDate = this.getTodayDateFormatted();
      let amount = parseFloat(this.amount.replace(/,/g, '')).toFixed(2);
      financesInstance
        .put(
          `members/${this.transaction.member_id}/transactions/${
            this.transaction.tid
          }`,
          { amount: amount, timestamp: todayDate }
        )
        .then(async () => {
          await this.getTableData({
            communityId: this.$store.getters.getActiveCommunity.id,
            tableName: 'transactions'
          });
          this.setTableData(this.transactions.data);
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loading = false;
          this.showFailModal();
        });
    },
    doesErrorExist() {
      return this.areFieldsEmpty() || this.numberFieldContainsLetters();
    },
    areFieldsEmpty() {
      const numberAmount = parseFloat(this.amount.replace(/,/g, '')).toFixed(2);
      return this.amount === '' || numberAmount <= 0;
    },
    numberFieldContainsLetters() {
      // return this.incomeAmount.match(/[a-zA-Z]/g) == true;
      return false;
    }
  },
  destroyed() {
    document.removeEventListener('keydown', this.processKeyboardEvent);
  }
};
</script>
<style lang="scss" scoped>
.body {
  padding: 2rem 0;
  display: flex;
}

hr {
  margin-top: 0;
}

.edit-transaction-income {
  .edit-input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    flex-direction: column;
    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      .ui.fluid.search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: #495057;
        transition: 0.2s all;
        height: calc(2.875rem + 2px);

        input {
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1.25rem;
          line-height: 1.5;
          max-width: 100%;
          border-radius: 0.3rem;
        }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: #5f5f5f;
          font-size: 1.5rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -2px -1px;
          .item {
            z-index: 15;
            padding: 4px 6px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            &:first-child {
              border-top: 1px solid rgba(0, 0, 0, 0.1);
            }
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }

    .amount--mod {
      width: 100%;
      // margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .data-wrapper {
    width: 100%;
    position: relative;
    .total {
      float: right;
      font-weight: 900;
      bottom: 0;
      position: absolute;
      right: 0;
    }
  }
}

.footer {
  width: 100%;

  .error {
    color: red;
    float: left;
    margin: 0 auto;
    margin-left: 1rem;
    display: flex;
    align-items: center;
  }

  .buttons {
    float: right;
    height: 38px;
    button:disabled {
      background-color: var(--primary-color-lighten);
      cursor: not-allowed;
    }

    button {
      height: 35px;
      min-width: 80px;
      width: 80px;
      text-align: center;
    }
  }
}
</style>
